export default "__VITE_ASSET__DoRSqZdK__"